var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseGridLayout',{attrs:{"size":"small"}},[_c('References',{attrs:{"id":_vm.anchorName,"headline":_vm.headline,"references":_vm.references}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }